import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const TabButtons = ({location}) => {
	const isCurrentPageEvent = location?.pathname?.includes('event');
	const isCurrentPageWebinar = location?.pathname?.includes('webinar');

	return (
		<Wrapper>
			<Link to={'/event'} className={isCurrentPageEvent ? 'active' : null}>Events</Link>
			<Link to={'/webinar'} className={isCurrentPageWebinar ? 'active' : null}>Webinars</Link>
		</Wrapper>
	)
}

export default TabButtons

const Wrapper = styled.div`
  width: max-content;
	margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 20px;

  a {
    color: white;
    font-size: 24px;
    display: block;
    position: relative;
	  text-transform: uppercase;
	  font-weight: 500;

    &::after {
      position: absolute;
      content: '';
      width: 0;
      height: 3px;
      left: 0;
      bottom: -2px;
      background: ${({ theme }) => theme.colors.primary_color};
      transition: ${({ theme }) => theme.durations.transition};
    }
    
    &.active {
      &::after {
        width: 100%;
      }
    }
  }
`